import BigNumber from 'bignumber.js';

export interface UniswapV3AlgebraRoute {
    /**
     * Resulting value in Wei.
     */
    outputAbsoluteAmount: BigNumber;
}
